module.exports = __webpack_public_path__ + "static/media/notification-settings-active-vector.fd6bd798.svg";